<div class="connect-delivery-customization-function-container">
  <form [formGroup]="formGroup">
    <div class="header">
      <div class="header-title">
        <pdq-heading element="h5">Delivery customization</pdq-heading>
        @if (requirements?.updateRequired) {
          <pdq-icon size="smaller" icon="Attention" color="var(--warning-default)"></pdq-icon>
        }
      </div>
      <pdq-slide-toggle
        formControlName="enableDeliveryCustomization"
        [defaultValue]="!!settings?.enableDeliveryCustomization">
        [disabled]="requirements?.updateRequired"
      </pdq-slide-toggle>
    </div>

    <div class="content">Enable PDQ to sort delivery options for customers</div>
  </form>
</div>
